import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import './staterefundstatus.css'; // Importing CSS specific to this page
import NavBar from '../components/Nav';
import Footer from '../components/footer'; // Same for Footer
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
const Staterefundstatus = () => {
    const stateLinks = [
        { state: "Alabama (AL)", link: "https://myalabamataxes.alabama.gov/_" },
        { state: "Alaska (AK)", link: "None" },
        { state: "Arizona (AZ)", link: "https://www.aztaxes.gov/Home/Login?aspxerrorpath=/Individual/CheckRefund.aspx" },
        { state: "Arkansas (AR)", link: "https://atap.arkansas.gov/_/#1" },
        { state: "California (CA)", link: "https://www.ftb.ca.gov/refund/index.asp?WT.mc_id=akRefund" },
        { state: "Colorado (CO)", link: "https://www.colorado.gov/revenueonline/_/#1" },
        { state: "Connecticut (CT)", link: "https://portal.ct.gov/DRS/Individuals/Income-Tax-Refunds" },
        { state: "Delaware (DE)", link: "https://de.gov/refundstatus" },
        { state: "Florida (FL)", link: "None" },
        { state: "Georgia (GA)", link: "https://etax.dor.ga.gov/_/" },
        { state: "Hawaii (HI)", link: "https://tax.hawaii.gov/geninfo/refund/" },
        { state: "Idaho (ID)", link: "https://tax.idaho.gov/i-1040-refund-status.cfm" },
        { state: "Illinois (IL)", link: "https://www.idor.illinois.gov/taxstatus" },
        { state: "Indiana (IN)", link: "https://www.in.gov/dor/tax-returns/" },
        { state: "Iowa (IA)", link: "https://tax.iowa.gov/individual-income-tax-refund-status" },
        { state: "Kansas (KS)", link: "https://www.kdor.ks.gov/tap" },
        { state: "Kentucky (KY)", link: "https://refunds.kentucky.gov/" },
        { state: "Louisiana (LA)", link: "https://www.revenue.louisiana.gov/Refunds" },
        { state: "Maine (ME)", link: "https://www.maine.gov/revenue/taxrelief/RefundStatus" },
        { state: "Maryland (MD)", link: "https://marylandtaxes.gov/" },
        { state: "Massachusetts (MA)", link: "https://www.mass.gov/service-details/check-the-status-of-your-tax-refund" },
        { state: "Michigan (MI)", link: "https://www.michigan.gov/taxes/individual-income-tax/refunds" },
        { state: "Minnesota (MN)", link: "https://www.revenue.state.mn.us/individual-income-tax-refund-status" },
        { state: "Mississippi (MS)", link: "https://www.dor.ms.gov/" },
        { state: "Missouri (MO)", link: "https://mydor.mo.gov/" },
        { state: "Montana (MT)", link: "https://mt.gov/revenue/refundstatus/" },
        { state: "Nebraska (NE)", link: "https://revenue.nebraska.gov/" },
        { state: "Nevada (NV)", link: "None" },
        { state: "New Hampshire (NH)", link: "None" },
        { state: "New Jersey (NJ)", link: "https://www.state.nj.us/treasury/taxation/" },
        { state: "New Mexico (NM)", link: "https://www.tax.newmexico.gov/individuals/" },
        { state: "New York (NY)", link: "https://www.tax.ny.gov/" },
        { state: "North Carolina (NC)", link: "https://www.ncdor.gov/taxes" },
        { state: "North Dakota (ND)", link: "https://www.nd.gov/tax/individual-income-tax/refund-status" },
        { state: "Ohio (OH)", link: "https://tax.ohio.gov/wps/portal/gov/tax/business/individual-income-tax-refund-status" },
        { state: "Oklahoma (OK)", link: "https://oklahoma.gov/tax" },
        { state: "Oregon (OR)", link: "https://www.oregon.gov/dor/individuals/pages/refund-status.aspx" },
        { state: "Pennsylvania (PA)", link: "https://www.revenue.pa.gov/" },
        { state: "Rhode Island (RI)", link: "https://www.tax.ri.gov/" },
        { state: "South Carolina (SC)", link: "https://www.sctax.org/" },
        { state: "South Dakota (SD)", link: "None" },
        { state: "Tennessee (TN)", link: "None" },
        { state: "Texas (TX)", link: "None" },
        { state: "Utah (UT)", link: "https://tax.utah.gov/" },
        { state: "Vermont (VT)", link: "https://tax.vermont.gov/" },
        { state: "Virginia (VA)", link: "https://www.tax.virginia.gov/refund-status" },
        { state: "Washington (WA)", link: "None" },
        { state: "West Virginia (WV)", link: "https://www.tax.wv.gov/" },
        { state: "Wisconsin (WI)", link: "https://www.revenue.wi.gov/" },
        { state: "Wyoming (WY)", link: "None" }
    ];
    

    return (
        <div>
         <Upperbox/>
            <NavBar />
            <div className="banner-section">
      <div className="banner-overlay">
        <h1 className="banner-title">State Refund Status</h1>
      </div>
    </div>
            <div className="refund-status-container">
                <div className="refund-status-section">
                    <div className="refund-header">
                        <h2>State Refund Status</h2>
                    </div>
                    <div className="refund-table">
                        <div className="table-header">
                            <div className="table-column">State</div>
                            <div className="table-column">Links</div>
                        </div>
                        {stateLinks.map((item, index) => (
                            <div className="refund-row" key={index}>
                                <div className="table-column refund-name">
                                    {item.state}
                                </div>
                                <div className="table-column refund-link">
                                    {item.link === "None" ? (
                                        "None"
                                    ) : (
                                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                                            Check Here
                                            <FontAwesomeIcon icon={faLink} className="refund-icon" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Whatsapp/>
            <ScrollTop/>
            <Footer />
        </div>
    );
};

export default Staterefundstatus;
